import { useCallback } from 'react';

import { Box } from '@twilio-paste/core/box';
import { Button } from '@twilio-paste/core/button';
import { DeleteIcon } from '@twilio-paste/icons/esm/DeleteIcon';
import { EditIcon } from '@twilio-paste/icons/esm/EditIcon';

import { TargetAuthHeaderFormValue } from '../types';

import { useTargetAuthHeaderContext } from './TargetAuthHeaderContext';

interface TargetAuthHeaderRowActionsProps {
  authHeader: TargetAuthHeaderFormValue;
}

export function TargetAuthHeaderTableRowActions({ authHeader }: TargetAuthHeaderRowActionsProps) {
  const { removeAuthHeader, readOnly, setEditItem } = useTargetAuthHeaderContext();

  const handleRemoveAuthHeader = useCallback(
    () => removeAuthHeader(authHeader),
    [authHeader, removeAuthHeader],
  );

  const handleEditAuthHeader = useCallback(
    () => setEditItem(authHeader),
    [authHeader, setEditItem],
  );

  const disableActions = readOnly || authHeader.editing;

  return (
    <Box display="flex" justifyContent="flex-end">
      <Button
        variant="primary_icon"
        title="Edit"
        onClick={handleEditAuthHeader}
        disabled={disableActions}
      >
        <EditIcon decorative />
      </Button>
      <Button
        variant="destructive_icon"
        title="Delete"
        onClick={handleRemoveAuthHeader}
        disabled={disableActions}
      >
        <DeleteIcon decorative />
      </Button>
    </Box>
  );
}
